import { Transfer } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { getFundamentos } from 'api/configuracion/fundamentosLegales';

const TransferInput = ({ fundamentosArray, callback }) => {
  const [mockData, setMockData] = useState([]);
  const [targetKeys, setTargetKeys] = useState([]);
  const [loading, setLoading] = useState(false);

  const setFundamentos = async ({ _fundamentos }) => {
    const tempTargetKeys = [];
    const tempMockData = [];

    _fundamentos.forEach((item) => {
      const data = {
        key: item.id.toString(),
        title: `${item.id} - ${item.denominacion}`,
        description: item.denominacion,
        chosen: false,
      };
      tempMockData.push(data);
    });

    fundamentosArray.forEach((item) => {
      const data = _fundamentos.find((element) => element.id === item);
      tempTargetKeys.push(data);
    });

    setMockData(tempMockData);
    setTargetKeys(tempTargetKeys.map((item) => item.id.toString()));
  };

  const getAllFundamentosCatalog = async () => {
    const request = await getFundamentos();
    if (request) {
      setFundamentos({ _fundamentos: request });
    }
  };

  useEffect(() => {
    setLoading(true);
    getAllFundamentosCatalog();
    setLoading(false);
  }, []);

  const filterOption = (inputValue, option) => option.description.indexOf(inputValue) > -1;
  const handleChange = (newTargetKeys) => {
    callback({ key: newTargetKeys });
    setTargetKeys(newTargetKeys);
  };

  return (
    <Transfer
      dataSource={mockData}
      style={{ justifyContent: 'center' }}
      listStyle={{ width: 800, height: 300 }}
      showSearch
      filterOption={filterOption}
      targetKeys={targetKeys}
      onChange={handleChange}
      render={(item) => item.title}
    />
  );
};

TransferInput.propTypes = {
  fundamentosArray: PropTypes.arrayOf(PropTypes.number).isRequired,
  callback: PropTypes.func.isRequired,
};

export default TransferInput;
